// IMPORTANT: this is a plugin which requires jQuery for initialisation and data manipulation

import {
  Component,
  OnInit,
  ElementRef,
  Inject,
  AfterViewInit,
} from "@angular/core";
import { Title } from "@angular/platform-browser";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { FormControl } from "@angular/forms";
import { UserService } from "../../services/user.service";
import { User } from "../../models/user";
import { FileCompanyService } from "../../services/filecompany.service";
import { Filecompany } from "../../models/filecompany";
import { FolderCompanyService } from "../../services/foldercompany.service";
import { Foldercompany } from "../../models/foldercompany";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import swal from "sweetalert2";

export interface UserList {
  value: string;
  name: string;
}

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare const $: any;

@Component({
  selector: "app-listfilescompany-cmp",
  templateUrl: "listfilescompany.component.html",
  styleUrls: ["./file-upload.component.scss"],
  providers: [UserService, FileCompanyService, FolderCompanyService],
})
export class ListfilescompanyComponent implements OnInit, AfterViewInit {
  // State for dropzone CSS toggling
  isHovering: boolean;

  public loading: boolean = false;

  name: string;
  animal: string;
  public dataTable: DataTable;
  public privilegio;
  sexos = [
    { value: "1", viewValue: "Hombre" },
    { value: "0", viewValue: "Mujer" },
  ];
  public pacientes: Array<User>;
  public files: Array<Filecompany>;
  public folder: Array<Foldercompany>;
  public identity;
  public token;
  public pages;
  public pagePrev;
  public pageNext;
  public filter = 0;
  public dataTablePOSearch: DataTable;
  public order = 0;
  public searchString;
  public user;
  public folderinterno;
  public file;
  public status_user;
  myControl = new FormControl();
  myControlClientes = new FormControl();
  public clientes;

  constructor(
    public dialog: MatDialog,
    private titleService: Title,
    private _route: ActivatedRoute,
    private _router: Router,
    private _userService: UserService,
    private _fileService: FileCompanyService,
    private _folderService: FolderCompanyService
  ) {
    this.titleService.setTitle("GTS Files");
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

    console.log(this.privilegio);
  }

  ngOnInit() {
    if (this.identity == null && this.identity.sub) {
      localStorage.clear();
      this._router.navigate(["/pages/lock"]);
    } else {
      this.getAllPacientes();
    }

    this.dataTablePOSearch = {
      headerRow: ["Folder Name", "Actions"],
      footerRow: ["Folder Name", "Actions"],

      dataRows: [],
    };
  }

  displayFn(user?: UserList): string | undefined {
    return user ? user.name : undefined;
  }

  private _filterClientes(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.clientes.filter(
      (option) => option.name.toLowerCase().indexOf(filterValue) === 0
    );
  }

  selectUserPermission(e) {
    console.log(e);
  }

  public showMsgPOSearchingNotResults = 0;
  public showsearchPOResults = 0;

  public showposearch = 0;
  public advancedpotext = "";

  showposrch() {
    if (this.showposearch) this.showposearch = 0;
    else this.showposearch = 1;
  }

  goFolder(folder) {
    // console.log(folder);
    // this._router.navigate(['/tables/listfilescompany', folder]);
    window.location.href = "/tables/listcompanyfiles/" + folder;
  }

  searchPO() {
    $("#showMsgPOSearching").show();
    this.dataTablePOSearch.dataRows = [];
    this.showMsgPOSearchingNotResults = 0;

    this._fileService
      .searchPO(this.privilegio.sub, this.advancedpotext)
      .subscribe(
        (response) => {
          $("#showMsgPOSearching").hide();
          console.log(response);
          console.log(response.length);
          if (response.length > 0) {
            this.showsearchPOResults = 1;
            this.showMsgPOSearchingNotResults = 0;
          } else {
            this.showsearchPOResults = 0;
            this.showMsgPOSearchingNotResults = 1;
          }
          response.forEach(
            function (element) {
              console.log(element.file);
              this.dataTablePOSearch.dataRows.push([
                element.id,
                element.folderName,
                "",
              ]);
            }.bind(this)
          );
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  deleteFolderfirst(folder) {
    var txt;
    var r = confirm("Are you sure to delete this folder?");
    if (r == true) {
      $("#folder" + folder).hide();
      $("#borrarFolder").val(folder);

      $("#borrarFolder").trigger("click");
    } else {
    }
  }

  deleteFolder() {
    this.loading = true;
    let id = $("#borrarFolder").val();
    console.log(id + "aqui");
    this._folderService.deleteFolder(this.token, id).subscribe(
      (response) => {
        if (response.status == "success") {
          //this._router.navigate(['/']);
          alert("Done");
          // this.getFiles(this.idFolder);
          console.log("deleted");
          this.loading = false;
        } else {
          alert("Error");
        }
      },
      (error) => {
        console.log(<any>error);
        alert("Error");
      }
    );
  }

  deleteUser() {
    let id = $("#borrarUser").val();
    console.log(id + "aqui");
    this._folderService.deleteFolder(this.token, id).subscribe(
      (response) => {
        if (response.status == "success") {
          //this._router.navigate(['/']);

          // this.getFiles(this.idFolder);
          console.log("deleted");
          this.loading = false;
        } else {
          alert("Error");
        }
      },
      (error) => {
        console.log(<any>error);
        alert("Error");
      }
    );
  }

  showSwal(type) {
    if (type === "success-message") {
      swal.fire({
        title: "Folder has been created",
        text: "",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else if (type === "warning-message-and-confirmation") {
      swal
        .fire({
          title: "Are you sure?",
          text: "You will not be able to revert this!",

          showCancelButton: true,

          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then(function () {
          swal.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",

            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        });
    } else if (type === "warning-message-and-cancel") {
      swal
        .fire({
          title: "Are you sure?",
          text: "You will not be able to recover this imaginary file!",

          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, keep it",

          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        })
        .then(
          function () {
            swal.fire({
              title: "Deleted!",
              text: "Your imaginary file has been deleted.",

              customClass: {
                confirmButton: "btn btn-success",
              },
              buttonsStyling: false,
            });
          },
          function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === "cancel") {
              swal.fire({
                title: "Cancelled",
                text: "Your imaginary file is safe :)",

                customClass: {
                  confirmButton: "btn btn-info",
                },
                buttonsStyling: false,
              });
            }
          }
        );
    } else if (type === "custom-html") {
      swal.fire({
        title: "HTML example",
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-success",
        },
        html:
          "You can use <b>bold text</b>, " +
          '<a href="http://github.com">links</a> ' +
          "and other HTML tags",
      });
    } else if (type === "auto-close") {
      swal
        .fire({
          title: "Auto close alert!",
          text: "I will close in 2 seconds.",
          timer: 2000,
          showConfirmButton: false,
        })
        .then(
          function () {},
          // handling the promise rejection
          function (dismiss) {
            if (dismiss === "timer") {
              console.log("I was closed by the timer");
            }
          }
        );
    } else if (type === "input-field") {
      swal
        .fire({
          title: "Input something",
          html:
            '<div class="form-group">' +
            '<input id="input-field" type="text" class="form-control" />' +
            "</div>",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        })
        .then(function (result) {
          swal.fire({
            html:
              "You entered: <strong>" + $("#input-field").val() + "</strong>",

            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        });
    }
  }

  openNuevoFolder(): void {
    this.folderinterno = new Foldercompany(1, "", "", "", 0, "", 0, 0, 1, 0);
    let dialogRef = this.dialog.open(NewFoldercompany, {
      data: { folder: this.folderinterno },
    });

    dialogRef.afterClosed().subscribe((result) => {
      //  result.folder.user_id = result.user_id.value;
      console.log(result);
      //console.log(result.folder);

      this._folderService.create(this.token, result).subscribe(
        (response) => {
          console.log(response);
          this.status_user = response.status;

          if (this.status_user != "success") {
            this.status_user = "error";
          } else {
            this.showSwal("success-message");
            //this.animal = result;
            this.getAllPacientes();
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });
  }

  getAllPacientes() {
    this._route.params.forEach((params: Params) => {
      let page = +params["page"];

      if (!page) {
        page = 1;
      }

      let typeFolders = "";

      if (
        this.privilegio.level == "ADMINISTRATOR"
        //|| this.privilegio.level == 'PURCHASINGREP'
      ) {
        typeFolders = "ALL";
      } /*else if(this.privilegio.level == 'worker'){
        typeFolders = 'ALL';
      } */ else {
        typeFolders = "USER";
      }

      this.loading = true;
      this._folderService.getFolders(this.token, page, typeFolders).subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.pacientes = response.data;

            this.dataTable = {
              headerRow: ["Type", "ID", "Client Name", "User", "Actions"],
              footerRow: ["Type", "ID", "Client Name", "User", "Actions"],

              dataRows: [],
            };

            this.pacientes.forEach(
              function (element) {
                this.dataTable.dataRows.push([
                  element.id,
                  element.name,
                  element.user.name + " " + element.user.surname,
                  "",
                  element.user.id,
                ]);
              }.bind(this)
            );

            this.loading = false;

            //total paginas
            this.pages = [];
            for (let i = 0; i < response.total_pages; i++) {
              this.pages.push(i);
            }

            //pagina anterior
            if (page >= 2) {
              this.pagePrev = page - 1;
            } else {
              this.pagePrev = page;
            }

            //pagina siguiente
            if (page < response.total_pages) {
              this.pageNext = page + 1;
            } else {
              this.pageNext = page;
            }
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });
  }

  ngAfterViewInit() {
    $("#datatables").DataTable({
      dom: "Bflrtip",
      buttons: [
        /*{
            extend: 'copy',
            exportOptions: {
              columns: ':visible'
            }
          },*/ /*
          {
            extend: 'csv',
            exportOptions: {
              columns: ':visible'
            }
          },*/
        {
          extend: "excel",
          text: '<i class="fa fa-file-excel-o"></i>',
          titleAttr: "Excel",
          className: "btn btn-sm btn-outline-success",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "pdf",
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: "PDF",
          className: "btn btn-sm btn-outline-danger",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "print",
          text: '<i class="fa fa-print" aria-hidden="true"></i>',
          titleAttr: "print",
          className: "btn btn-sm btn-outline-primary",
          exportOptions: {
            columns: ":visible",
          },
        },
      ],
      pagingType: "full_numbers",
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"],
      ],
      responsive: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search records",
      },
    });

    const table = $("#datatables").DataTable();

    // Edit record
    table.on("click", ".edit", function () {
      const $tr = $(this).closest("tr");

      const data = table.row($tr).data();
      // alert('You press on Row: ' + data[0] + ' ' + data[1] + ' ' + data[2] + '\'s row.');
    });

    //Like record
    table.on("click", ".like", function () {});

    $(".card .material-datatables label").addClass("form-group");
  }
}

@Component({
  selector: "new-folder",
  templateUrl: "new-folder.html",
  providers: [UserService, FileCompanyService, FolderCompanyService],
})
export class NewFoldercompany implements OnInit, AfterViewInit {
  public userinterno;
  public loading: boolean = false;
  public identity;
  public token;
  public user: User;
  public status_user;
  public privilegio;
  public pacientes;
  public folder;
  public productosResponse;
  myControl = new FormControl();
  myControlClientes = new FormControl();

  public permissionsShow;
  sexos = [
    { value: "1", viewValue: "Male" },
    { value: "0", viewValue: "Female" },
  ];

  clientes: UserList[] = [];

  filteredClientes: Observable<UserList[]>;
  public usertoAssign: Array<any> = [];

  constructor(
    public dialogRef: MatDialogRef<NewFoldercompany>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserService,
    private _fileService: FileCompanyService,
    private _folderService: FolderCompanyService,
    private _route: ActivatedRoute,
    private _router: Router
  ) {
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.folder = data;
    this.loading = true;
    this.folder.permissions = this.folder.permissions || [];
    this.permissionsShow = [];
    console.log(this.folder.permissions);

    /* this._userService.getAllUsers(this.token). subscribe(
        response =>{
          console.log(response);
          if(response.status == 'success'){
            this.loading = false;
            this.pacientes = response.data;
              console.log(this.pacientes);


          
        
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
        },
        error => {
          console.log(<any>error);
        }
        ); */
  }

  ngOnInit() {
    console.log("5555");
    if (this.identity == null && this.identity.sub) {
      this._router.navigate(["/pages/lock"]);
    } else {
    }

    this.getListUsers("exceptuser");
  }

  ngAfterViewInit() {}

  pipeusers(user) {
    console.log(user.name, "user");
    return user.name;
  }
  displayFn(user?: UserList): string | undefined {
    return user ? user.name : undefined;
  }

  private _filterClientes(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.clientes.filter(
      (option) => option.name.toLowerCase().indexOf(filterValue) === 0
    );
  }

  async getListUsers(type) {
    this.loading = true;
    let responsefolder = await this._userService
      .getAllUsersLite(this.token, type)
      .toPromise()
      .then(
        (response) => {
          console.log("lite");
          console.log(response);
          this.loading = false;
          if (response.status == "success") {
            response.data.forEach(
              function (element) {
                this.clientes.push({
                  value: element.id,
                  name:
                    element.name + " " + element.surname + " # " + element.id,
                });
                this.usertoAssign.push({
                  value: element.id,
                  name:
                    element.name + " " + element.surname + " # " + element.id,
                });
              }.bind(this)
            );
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );

    this.filteredClientes = this.myControlClientes.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) => (name ? this._filterClientes(name) : this.clientes.slice()))
    );

    console.log(this.filteredClientes);
    console.log(this.clientes);
  }

  selectPacient(event) {
    //console.log(event.value);

    this._userService.getUser(this.token, event.value).subscribe(
      (response) => {
        if (response.status == "success") {
          this.userinterno = response.data;
          console.log(this.userinterno);
          this.folder.user_id = this.userinterno.id;
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }
  deletePermiso(borrar) {
    var res = borrar.split("#");
    res = res[1].trim();
    res = parseInt(res);

    console.log(this.folder.permissions);

    for (var i = this.folder.permissions.length - 1; i >= 0; i--) {
      console.log(this.folder.permissions[i]);
      if (this.folder.permissions[i] === res) {
        this.folder.permissions.splice(i, 1);
      }
    }

    for (var i = this.permissionsShow.length - 1; i >= 0; i--) {
      console.log(this.permissionsShow[i]);
      if (this.permissionsShow[i] === borrar) {
        this.permissionsShow.splice(i, 1);
      }
    }

    console.log(this.folder.permissions);
  }

  selectUserPermission() {
    let userSelected = $("#nameCliente").val();

    console.log(this.folder.user_id);
    this.folder.permissions.push(this.folder.user_id.value);
    this.permissionsShow.push(this.folder.user_id.name + "");
    console.log(this.folder.permissions);
  }

  addItem() {
    console.log("add item");
  }

  onNoClick(): void {}
}
